The event signaling that a posted `PositionProfile` has been closed.
